import { render, staticRenderFns } from "./CampaignGroupActions.vue?vue&type=template&id=522a8f96&"
import script from "./CampaignGroupActions.vue?vue&type=script&lang=js&"
export * from "./CampaignGroupActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports